import { isPublicRfqResponsePath } from './publicResponseRoute'

let signingIn = false
let retainedShell: HTMLElement | undefined
const publicLanding =
  window.location.pathname === '/' && window.self === window.top
const publicRfqResponse = isPublicRfqResponsePath(window.location.pathname)

document.addEventListener('click', (event) => {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return
  const link =
    event.target instanceof Element
      ? event.target.closest<HTMLAnchorElement>('a[data-startup-sign-in]')
      : null
  if (
    !link ||
    link.hasAttribute('download') ||
    (link.target && link.target !== '_self')
  )
    return
  // Embedded login needs tenant configuration and the existing popup flow.
  if (window.parent !== window.self) return
  event.preventDefault()
  if (signingIn) return
  signingIn = true
  const appOwnsAuth = document.documentElement.dataset.startupAuth === 'app'
  if (!appOwnsAuth) document.documentElement.dataset.startupAuth = 'shell'

  // Keep the original shell outside React's root while bootstrap finishes.
  const shell = link.closest<HTMLElement>('.startup-shell')
  const root = document.getElementById('root')
  if (!publicLanding && !appOwnsAuth && shell && root?.contains(shell)) {
    root.before(shell)
    retainedShell = shell
  }
  link.setAttribute('aria-disabled', 'true')
  const status = shell?.querySelector<HTMLElement>('.startup-shell__status')
  if (status) {
    status.hidden = true
    status.textContent = ''
  }
  const login = appOwnsAuth
    ? new Promise<void>((resolve, reject) => {
        window.dispatchEvent(
          new CustomEvent('startup-sign-in', { detail: { resolve, reject } }),
        )
      })
    : import('./startupSignIn').then(({ startupSignIn }) => startupSignIn())
  void login.catch((error) => {
    console.error('Unable to start sign in', error)
    signingIn = false
    link.removeAttribute('aria-disabled')
    shell?.setAttribute('aria-busy', 'false')
    if (status?.isConnected) {
      status.hidden = false
      status.textContent =
        'Unable to open sign in. Select Sign in to try again.'
    } else {
      window.location.assign('/login' + window.location.search)
    }
  })
})

window.addEventListener('pageshow', (event) => {
  signingIn = false
  document
    .querySelectorAll('[data-startup-sign-in]')
    .forEach((link) => link.removeAttribute('aria-disabled'))
  if (publicLanding) {
    const status = document.querySelector<HTMLElement>('.startup-shell__status')
    if (status) status.hidden = true
  }
  if (
    !event.persisted ||
    document.documentElement.dataset.startupAuth !== 'shell'
  )
    return
  retainedShell?.remove()
  retainedShell = undefined
  delete document.documentElement.dataset.startupAuth
  window.dispatchEvent(new Event('startup-auth-reset'))
})

// Public sign-in does not need React, CAD, tables, telemetry, or the application store.
const startup = publicLanding
  ? import('./startupSignIn').then(async ({ checkStartupSession }) => {
      document
        .querySelector('.startup-shell')
        ?.setAttribute('aria-busy', 'false')
      // Warm the session, but entering the app always requires a button click.
      await checkStartupSession().catch(() => false)
    })
  : publicRfqResponse
    ? import('./publicResponseBootstrap')
    : import('./bootstrap')

void startup.catch((error) => {
  console.error('Unable to start the application', error)
  if (document.documentElement.dataset.startupAuth === 'shell') return
  const status = document.querySelector('.startup-shell__status')
  if (status) {
    status.removeAttribute('hidden')
    status.textContent = 'Unable to load the application. '
    const retry = document.createElement('a')
    retry.href = window.location.href
    retry.addEventListener('click', (event) => {
      event.preventDefault()
      window.location.reload()
    })
    retry.textContent = 'Reload to try again'
    status.appendChild(retry)
    status.closest('[aria-busy]')?.setAttribute('aria-busy', 'false')
  }
})
